import { channelsCheck } from 'services/api/user/controlPin/channelsCheck';
import Logger from 'services/logger';
//import { store } from 'store';

export const checkChannelBlocked = async (groupId, token) => {
  try {
    // console.log('payer', store?.Player?.Content?.data?.group?.common?.id);
    // console.log('VOd', store?.Vcard?.Content?.group?.common?.id);
    let idGroup;
    const path = window.location.pathname;
    const segmentos = path?.split('/')?.filter(Boolean);
    const indexWatch = segmentos?.indexOf('watch');
    const indexId = indexWatch + 1;
    if (indexWatch) {
      idGroup = segmentos?.[indexId];
    }

    const response = await channelsCheck({
      group_id: groupId || idGroup,
      user_token: token,
    });

    return response?.channels_check || false;
  } catch (error) {
    if (error === 500) {
      return { sensitive_error: true };
    }
    Logger.error('Error checking if channel is blocked:', error);
    return false;
  }
};
